import { render, staticRenderFns } from "./start_sim.vue?vue&type=template&id=35ff8317&scoped=true&"
import script from "./start_sim.vue?vue&type=script&lang=js&"
export * from "./start_sim.vue?vue&type=script&lang=js&"
import style0 from "./start_sim.vue?vue&type=style&index=0&id=35ff8317&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ff8317",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
